/**
 * @generated SignedSource<<db273d0f9cdeae0584b95a87dbcffedc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProfileInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteProfileMutation$variables = {
  input: DeleteProfileInput;
};
export type DeleteProfileMutation$data = {
  readonly deleteProfile: {
    readonly deletedProfileId: string | null;
  } | null;
};
export type DeleteProfileMutation = {
  variables: DeleteProfileMutation$variables;
  response: DeleteProfileMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProfilePayload",
    "kind": "LinkedField",
    "name": "deleteProfile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProfileId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProfileMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProfileMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7a399208c4284bae138808994c2ea692",
    "id": null,
    "metadata": {},
    "name": "DeleteProfileMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProfileMutation(\n  $input: DeleteProfileInput!\n) {\n  deleteProfile(input: $input) {\n    deletedProfileId\n  }\n}\n"
  }
};
})();

(node as any).hash = "78a0f7398eef053bc01ab93f781d6d53";

export default node;
